import Slider, { SlideItem } from 'components/organisms/Slider';
import { Container, Row, Col, BreakPoint } from 'components/atoms/Grid';
import styled, { css } from 'styled-components';
import Colors from 'components/tokens/Colors';
import Text from 'components/atoms/Text';
import Newsletter from './Newsletter';
import { sbEditable } from '@storyblok/storyblok-editable';

const mockCards = [
    { title: 'Como combater a infodemia no processo eleitoral?' },
    { title: 'Como combater a infodemia no processo eleitoral?' },
    { title: 'Como combater a infodemia no processo eleitoral?' }
];

function MainNews(props) {
    return (
        <>
            <MainContainer {...sbEditable(props)}>
                <Row>
                    <Col size="12" px="0">
                        <Slider
                            dots={false}
                            autoplay={false}
                            infinite={false}
                            arrows
                            arrowsColor={Colors.white}
                            education
                        >
                            {mockCards.map((item, index) => (
                                <SlideItem bg={Colors.black} key={index}>
                                    <ContentBanner>
                                        <ContainerCustom>
                                            <Row justifyContent="flex-end" className="row-banner">
                                                <Col size="12 6" px="0">
                                                    <ImageBannerFull bg={'https://picsum.photos/600'} />
                                                </Col>
                                            </Row>
                                        </ContainerCustom>
                                        <Container px="1.5 0">
                                            <Row>
                                                <Col size="12 6">
                                                    <Row pt="8">
                                                        <Col size="12" mb="1 3">
                                                            <Text
                                                                color={Colors.white}
                                                                title
                                                                size="48 72"
                                                                lineHeight="40 64"
                                                            >
                                                                {item.title}
                                                            </Text>
                                                        </Col>
                                                        <Col size="12" mb="15 0">
                                                            <Text color={Colors.white} body1 highlight>
                                                                Democracia digital
                                                            </Text>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </ContentBanner>
                                </SlideItem>
                            ))}
                        </Slider>
                    </Col>
                </Row>
            </MainContainer>
            {Newsletter(props?.newsletter[0])}
        </>
    );
}

const MainContainer = styled.div`
    width: 100%;
    background: ${Colors.black};
    padding-left: 0;

    @media (min-width: 768px) {
        padding-left: 64px;
    }

    > div {
        max-width: 100%;
        margin-left: 0;
    }

    .slider-c {
        .slick-slider {
            > div:nth-child(1),
            > div:nth-child(3) {
                left: 16px;
                top: 45%;

                @media (min-width: 768px) {
                    top: 85%;
                    left: 0;
                }

                @media (min-width: 1720px) {
                    left: 8%;
                }
            }

            > div:nth-child(3) {
                right: none;
                left: 6px;

                @media (min-width: 768px) {
                    left: 9%;
                }

                @media (min-width: 1720px) {
                    left: 13%;
                }
            }
        }
    }
`;

const ContentBanner = styled.div`
    width: 100%;
    color: ${Colors.white};
    position: relative;
    display: flex;
    flex-direction: column;
`;

const ContainerCustom = styled.div`
    height: 100%;
    width: 100%;
    position: relative;
    order: 2;

    ${BreakPoint(
        'sm',
        css`
            position: absolute;
            order: 0;
        `
    )}

    .row-banner {
        height: 100%;
    }
`;

const ImageBannerFull = styled.div`
    width: 100%;
    padding-top: 64%;
    background-size: cover;
    background-position: center;
    ${props => css`
        background-image: url('${props.bg}');
    `}

    @media (min-width: 768px) {
        padding-top: 114%;
    }
`;

export default MainNews;
